import request from "@/utils/request";

// 关于我们
// export const about

// 文章管理
export const articleList = (params) =>
  request({
    url: "/api/backend/basics/article/list",
    method: "GET",
    params,
  });

// 测评商品分类

// 列表
export const productCategoriesList = (params) =>
  request({
    url: "/api/backend/basics/evaluation/class/list",
    method: "GET",
    params,
  });

export const createClassify = (form) =>
  request({
    url: "/api/backend/basics/evaluation/class/add",
    method: "POST",
    data: {
      ...form,
    },
  });

// 上下架
export const changeState = (id) =>
  request({
    url: "/api/backend/basics/evaluation/class/state",
    method: "POST",
    data: {
      id,
    },
  });

// 删除
export const delEvent = (id) =>
  request({
    url: "/api/backend/basics/evaluation/class/del",
    method: "POST",
    data: {
      id,
    },
  });

// 测评领域管理
export const reviewArea = {
  // 添加
  create: (form) =>
    request({
      url: "/api/backend/basics/evaluation/field/add",
      method: "POST",
      data: { ...form },
    }),
  // 列表
  list: (params) =>
    request({
      url: "/api/backend/basics/evaluation/field/list",
      method: "GET",
      params,
    }),
  // 上下架
  changeState: (id) =>
    request({
      url: "/api/backend/basics/evaluation/field/state",
      method: "POST",
      data: {
        id,
      },
    }),
  // 删除
  delEvent: (id) =>
    request({
      url: "/api/backend/basics/evaluation/field/del",
      method: "POST",
      data: {
        id,
      },
    }),
};

// 问卷模板
export const questionnaire = {
  list: (params) =>
    request({
      url: "/api/backend/basics/questionnaire/list",
      method: "GET",
      params,
    }),
  addUpdate: (data) =>
    request({
      url: "/api/backend/basics/questionnaire/add",
      method: "POST",
      data: { ...data },
    }),
  changeState: (id) =>
    request({
      url: "/api/backend/basics/questionnaire/state",
      method: "POST",
      data: { id },
    }),
};

export const cooperation = {
  list: (params) =>
    request({
      url: "/api/backend/basics/cooperation/list",
      method: "GET",
      params,
    }),
  delete: (id) =>
    request({
      url: "/api/backend/basics/cooperation/del",
      method: "POST",
      data: { id },
    }),
};
